// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5922":"3ac81e2b","9926":"1838c606"}[chunkId] + ".chunk.css";
};